export default __webpack_public_path__ + "static/media/Kathai_grey.edcd25bb.png";